module.exports = __webpack_public_path__ + "media/images/flags/1x1/gtm-a7d45be1d39f16f7efc91b38c6920c92.svg";